import React from "react";
import { Box, Skeleton, Grid, Paper } from "@mui/material";

const OrderCardSkeleton = () => (
    <Paper
        elevation={0}
        sx={{
            mb: 2,
            borderRadius: 3,
            border: "1px solid #F0E0E8",
            overflow: "hidden",
        }}
    >
        {/* Top bar */}
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                px: 2.5,
                py: 1.5,
                borderBottom: "1px solid #F5E8EF",
                background: "#FEFAFC",
            }}
        >
            <Box sx={{ display: "flex", gap: 2 }}>
                <Skeleton variant="text" width={100} height={24} />
                <Skeleton variant="text" width={80} height={24} />
            </Box>
            <Skeleton variant="rounded" width={100} height={24} sx={{ borderRadius: 3 }} />
        </Box>

        {/* Content */}
        <Box sx={{ px: 2.5, py: 2 }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <Skeleton variant="text" width="80%" height={16} />
                    <Skeleton variant="text" width="60%" height={16} />
                </Grid>
                <Grid item xs={6} sm={3} md={2}>
                    <Skeleton variant="text" width={50} height={14} />
                    <Skeleton variant="text" width={70} height={20} />
                </Grid>
                <Grid item xs={6} sm={3} md={2}>
                    <Skeleton variant="text" width={50} height={14} />
                    <Skeleton variant="text" width={70} height={20} />
                </Grid>
                <Grid item xs={6} sm={3} md={2}>
                    <Skeleton variant="text" width={50} height={14} />
                    <Skeleton variant="text" width={70} height={20} />
                </Grid>
                <Grid item xs={6} sm={3} md={2}>
                    <Skeleton variant="text" width={50} height={14} />
                    <Skeleton variant="text" width={70} height={20} />
                </Grid>
            </Grid>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 1,
                    mt: 2,
                    pt: 1.5,
                    borderTop: "1px solid #F5E8EF",
                }}
            >
                <Skeleton variant="rounded" width={120} height={32} sx={{ borderRadius: 2 }} />
                <Skeleton variant="rounded" width={100} height={32} sx={{ borderRadius: 2 }} />
            </Box>
        </Box>
    </Paper>
);

const OrdersSkeleton = ({ count = 3 }) => (
    <Box sx={{ mt: 2 }}>
        {Array.from({ length: count }).map((_, index) => (
            <OrderCardSkeleton key={index} />
        ))}
    </Box>
);

export default OrdersSkeleton;
